import { isAuthenticated } from 'modules/common/permissions';

import { QUOTE_PART_VIEWER_ROUTE_PREFIX } from '../constants';
import QuotePartViewer from '../entry';
import { initQuotePartViewer } from './sagas';

export default [
  {
    component: QuotePartViewer,
    exact: true,
    path: `${QUOTE_PART_VIEWER_ROUTE_PREFIX}/:quoteNum`,
    helpId: 'quoteFileViewer',
    permissions: [isAuthenticated],
    saga: initQuotePartViewer,
  },
];
